import { useState } from 'react';
import PropTypes from 'prop-types';
import { logger } from '@activebrands/core-web/utils/logger';
import AdyenDropIn from 'templates/CheckoutPage/PaymentSection/Payment/PaymentMethods/AdyenDropIn';
import KlarnaCheckout from 'templates/CheckoutPage/PaymentSection/Payment/PaymentMethods/KlarnaCheckoutV3';

const paymentMethodComponentMapper = {
    'adyen-drop-in-us': AdyenDropIn,
    'adyen-drop-in': AdyenDropIn,
    'klarna': KlarnaCheckout,
};

const PaymentMethods = ({ paymentMethodId, paymentMethods }) => {
    const [loading, setLoading] = useState(true);
    const matchingPaymentMethods = paymentMethods.find(pm => pm.id === paymentMethodId);

    if (!matchingPaymentMethods) {
        logger.error(`The payment method (${paymentMethodId}) is not available.`);
        return <p>The payment method ({paymentMethodId}) is not available.</p>;
    }
    const PaymentComponent = paymentMethodComponentMapper[paymentMethodId];

    if (!PaymentComponent) {
        logger.error(
            `The payment method (${paymentMethodId}) is not allowed. Please configure paymentMethods in the PaymentMethods -> index.js file.`
        );
        return <p>The payment method ({paymentMethodId}) is not allowed.</p>;
    }
    return <PaymentComponent loading={loading} setLoading={setLoading} />;
};

PaymentMethods.propTypes = {
    paymentMethodId: PropTypes.oneOf([PropTypes.number, PropTypes.string]).isRequired,
    paymentMethods: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default PaymentMethods;
